module.exports = __webpack_public_path__ + "img/ic_speech_bubble_hover.43f83115.svg";